import { Link } from 'react-router-dom'
import { DualListPicker } from '@/components/common/DualListPicker'
import { useProducts, useConfigurationComposition, useSetConfigurationComposition } from '@/features/product/hooks'
import type { Product } from '@/features/product/types'

/** Picker stałej kompozycji konfiguracji: które produkty-elementy zawiera ten typ umowy. */
export function CompositionPanel({ configurationCode }: { configurationCode: string }) {
  const allQ = useProducts()
  const compQ = useConfigurationComposition(configurationCode)
  const setComp = useSetConfigurationComposition(configurationCode)

  if (allQ.isLoading || compQ.isLoading) return <div>Ładowanie produktów...</div>
  if (!allQ.data) return null

  const all = allQ.data
  const selectedCodes = compQ.data ?? []
  const byCode = new Map(all.map((p) => [p.code, p]))
  const selected = selectedCodes.map((c) => byCode.get(c)).filter((p): p is Product => p != null)
  const selectedSet = new Set(selectedCodes)
  const available = all.filter((p) => !selectedSet.has(p.code))

  return (
    <div className="flex flex-col gap-3 text-sm">
      <p className="text-xs text-slate-500">
        Wybierz produkty-elementy składające się na ten typ umowy (np. fotowoltaika + magazyn). Każda umowa tej
        konfiguracji dostanie te elementy. Produkty definiujesz w{' '}
        <Link to="/settings/dictionaries" className="text-sky-700 underline">Słownikach → Produkty</Link>.
      </p>

      <DualListPicker
        available={available}
        selected={selected}
        getId={(p) => p.code}
        renderItem={(p) => (
          <div className="flex items-baseline gap-2">
            <span>{p.labelPl}</span>
            <span className="font-mono text-[10px] text-slate-400">{p.code}</span>
          </div>
        )}
        onChange={(codes) => setComp.mutate(codes.map(String))}
        availableLabel="Dostępne produkty"
        selectedLabel="W tej konfiguracji"
        emptyAvailable={<span>Brak produktów - dodaj w Słownikach → Produkty (elementy)</span>}
        emptySelected={<span>Przeciągnij produkty tutaj</span>}
      />
    </div>
  )
}
